export const dadosUsoCientifico = [
  {
    id: '1',
    tipo: 'TCC',
    titulo:
      'Um relato de experiência exitosa da implantação do monitoramento e avaliação dos indicadores do Previne Brasil em um município do interior do Estado da Bahia',
    autor: 'FRANCISCO AUBER PERGENTINO VIEIRA',
    autores: [
      'FRANCISCO AUBER PERGENTINO VIEIRA',
      'LUCIANO MONTALVÃO TEIXEIRA',
      'MARCUS VINÍCIUS DIAS GADELHA',
    ],
    ano: '2022',
    local: 'UFG',
    resumo: `Trata-se de uma proposta de trabalho como relato de experiência sobre as ações de
monitoramento e avaliação dos indicadores de desempenho do novo financiamento,
o programa Previne Brasil, no nível da Atenção Primária à Saúde, no município de
Presidente  Jânio  Quadros,  localizado  na  região  sudoeste,  no  interior  do  Estado  da
Bahia.  Este  estudo  tem  como  finalidade  relatar  estas  ações  para  qualificar  os
cadastros individuais, os registros dos atendimentos e procedimentos individuais, e o
monitoramento e avaliação dos indicadores com o objetivo de alcançar a cobertura
mínima daqueles  que nunca haviam  alcançados e elevar  aqueles já  alcançados. A
partir do relato desta vivência, espera-se que haja a produção de estudos científicos
descrevendo  a  correlação  das  ações  de  educação  permanente  em  saúde  e  do
monitoramento e avaliação dos indicadores do Previne Brasil.
`,
    doi: '',
    link: 'https://biaticefb.bitrix24.com.br/~9kec1',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://ufg.br/',
  },
  {
    id: '2',
    tipo: 'Artigo científico',
    titulo:
      'Perfil dos usuários diabéticos atendidos em uma unidade básica de saúde no sertão paraibano',
    autor: 'Eloizy Mariana Dias de Medeiros Cirilo Costa',
    autores: [
      'Eloizy Mariana Dias de Medeiros Cirilo Costa',
      'Milena Nunes Alves de Sousa',
    ],
    ano: '2023',
    local: 'UNIFIP',
    resumo:
      'O diabetes mellitus é um relevante e crescente problema de saúde pública para todos os países, independentemente do seu grau de desenvolvimento socioeconômico. Representa uma importante carga financeira para os cofres públicos em razão das maiores taxas de hospitalizações, maior utilização dos serviços de saúde, gastos com terapêutica medicamentosa, perda de produtividade e cuidados prolongados para tratamento de complicações. O presente estudo tem a finalidade de reconhecer o perfil clínico-epidemiológico dos usuários diabéticos atendidos em uma unidade básica de saúde no sertão paraibano. Trata-se de um estudo do tipo transversal, descritivo, com abordagem quantitativa que utilizará dados secundários existentes em prontuário eletrônico, coletados a partir de um questionário contendo variáveis para caracterização sociodemográfica e investigação de aspectos clínicos. Obteve-se uma amostra de 141 diabéticos com idade média de 62,7 anos, sendo a maioria do sexo feminino e categorizados como diabéticos tipo 2. Em relação às comorbidades, descaram-se hipertensão arterial sistêmica e dislipidemia. Quanto às complicações crônicas, constatou-se acidente vascular encefálico, doença arterial coronariana, neuropatia e nefropatia diabética. A maioria dos pesquisados apresentava bom controle glicêmico e utilizava antidiabético oral. Com relação à função renal, houve predomínio de insuficiência renal leve – estágio 2. Avaliando a situação nutricional, observou-se prevalência de obesidade na população geral e sobrepeso nos idosos.  Torna-se de suma importância o reconhecimento dos diabéticos e de suas condições de saúde, a fim de identificar as suas necessidades e adequar as ações assistenciais, oportunizado um cuidado integral e qualificado.',
    doi: 'https://doi.org/10.56083/RCV3N3-030',
    link: 'https://ojs.revistacontemporanea.com/ojs/index.php/home/article/view/499',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://unifip.edu.br/inicio',
  },
  {
    id: '3',
    tipo: 'Artigo científico',
    titulo:
      'Utilização do processo de avaliação e monitoramento aliado ao uso da ferramenta computacional êsus Feedback na melhoria dos indicadores da atenção primária no município de serranópolis de minas-MG',
    autor: 'Almir Rogério da Silva Lopes',
    autores: [
      'Almir Rogério da Silva Lopes',
      'Melise Carina Duarte de Almeida',
    ],
    local: 'UFRN',
    ano: '2022',
    resumo: `O Previne Brasil se apresenta como um novo modelo de financiamento da atenção primária a saúde, não sendo mais fixo e agora baseado em 3 componentes que são: capitação ponderada, indicadores de desempenho e as ações estratégicas. Sendo que, os indicadores de desempenho são divididos em: apoio ao Cuidado a Gestante cujos componentes são as consultas de pré-natal, exames de HIV e Sífilis e Consultas Odontológicas; a Saúde da Mulher que compõe o percentual de coletas de Citopatológicos; a Imunização das crianças até um ano de idade com a aplicação das vacinas Pólio e Penta e por fim o cuidado com as Doenças Crônicas onde são avaliados o percentual de Solicitação de Hemoglobina Glicada dos diabéticos e de Acompanhamento aos hipertensos; que ao final nos dará o ISF (Indicador Sintético Final) cuja variação é de 0 a 10, sendo o mínimo aceitável 7. O trabalho teve como objetivo principal a melhoria desses Indicador que prospecta o nível de acompanhamento da população por parte dos profissionais da Atenção Primária a Saúde. Neste contexto, localmente, verificamos problemas tais como: diminuição do fluxo de pacientes em decorrência da Pandemia, falta de qualificação dos profissionais, ausência de
uma ferramenta de gerenciamento adequado além de poucas ações estratégicas nas equipes. Para o processo de intervenção utilizamos a ferramenta de gestão em saúde conhecida como êSUS Feedback aliado a processos de qualificação utilizando ferramentas computacionais além de semestralmente serem feitos processos de Avaliação e Monitoramento das ações das equipes. A verificação dos resultados alcançados foi baseada nas fontes reais dos resultados do Indicador Sintético Final (ISF), composto pelos indicadores de desempenho, desde o primeiro quadrimestre de 2018 até o terceiro quadrimestre de 2021, de forma quantitativa, através de relatórios públicos presentes no portal do SISAB. Percebeu-se uma melhoria excelente nos indicadores, onde o município passou de uma nota 3.08 no primeiro quadrimestre de 2021 para 9.8 no terceiro quadrimestre de 2021, isto mostra uma melhoria de 318%.`,
    doi: '',
    link: 'https://biaticefb.bitrix24.com.br/~q9skV',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://www.ufrn.br/',
  },
  {
    id: '4',
    tipo: 'Apresentação',
    titulo:
      'SISTEMA DIGITAL DE GESTÃO NA ATENÇÃO PRIMÁRIA À SAÚDE: ESTUDO DE VALIDAÇÃO',
    autor: 'Mailson Silva de Oliveira',
    autores: [],
    local: 'UFDPar',
    ano: '2024',
    resumo: '',
    doi: '',
    link: '',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://profsaude.ufdpar.edu.br/',
  },
  {
    id: '5',
    tipo: 'eBook',
    titulo: 'Gestão pública na região amazônica',
    autor: 'Juliano Milton Kruger',
    autores: [
      'Juliano Milton Kruger',
      'Daniel Cerdeira de Souza',
      'Taiã Mairon Peixoto Ribeiro',
      'Tânia Midian Freitas de Souza',
    ],
    local: 'IFAM',
    ano: '2023',
    resumo: `O medicalizar consiste em interpretar assuntos de natureza pessoal, política,
econômica e social do ponto de vista médico, patologizando a vida cotidiana.
Nosso objetivo foi analisar a literatura publicada no formato de artigos científicos
publicados entre 2017-2021 sobre medicalização na escola no contexto
brasileiro. O estudo consiste em uma revisão integrativa, que analisou 25 artigos
coletados no Portal Periódicos CAPES e na Biblioteca Virtual de Saúde. Os
dados foram analisados a partir de um protocolo de revisão e posteriormente
pelo procedimento de Análise de Conteúdo. Os dados extraídos dos artigos
possibilitaram a construção de cinco categorias: 1) Medicalização no âmbito
escolar; 2) Caráter individual dos problemas escolares; 3) Medicalização como
salvação; 4) Fracasso escolar e o não-aprender; 5) Educação reducionista,
que discutiram que a escola usa da medicalização para justificar o fracasso
escolar, sem se responsabilizar pela produção deste fenômeno, além de
que a medicalização parece assumir um papel salvacionista nos contextos
escolares. Concluímos que o ambiente escolar se encontra atravessado pelo
conhecimento científico da área da saúde e que busca no campo da medicina
a solução para os problemas de aprendizagem e comportamento, por fim, propomos
a utilização do Desenho Universal para a Aprendizagem para romper
com práticas medicalizantes na escola.`,
    doi: 'https://doi.org/10.31560/pimentacultural/2023.96146',
    link: 'https://www.pimentacultural.com/livro/gestao-amazonia-3/',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://www2.ifam.edu.br/',
  },
  {
    id: '6',
    tipo: 'ANAIS',
    titulo:
      'ANAIS DA 84ª SEMANA BRASILEIRA DE ENFERMAGEM E 53ª JORNADA MARANHENSE DE ENFERMAGEM VALORIZAÇÃO DO TRABALHO EM ENFERMAGEM COM DESENVOLVIMENTO SUSTENTÁVEL E BEM VIVER',
    autor: 'Maria Lucia Holanda Lopes',
    autores: [
      'Maria Lucia Holanda Lopes',
      'Silvia Cristina Viana Silva Lima',
      'Patrícia Ribeira Azevedo',
      'Nair Portela Silva Coutinho',
      'Dorlene Maria Cardoso de Aquino',
      'Michael Jackson S. dos Santos',
    ],
    local: 'UFMA',
    ano: '2023',
    resumo: `Introdução: a Enfermagem tem um papel relevante nas lutas políticas contra as desigualdades sociais, sobretudo, aquelas que tratam de pautas pela igualdade de gênero e participação política da mulher, que decorrem da luta política do movimento feminista que reivindicava a liberdade de representação no trabalho. Objetivo: evidenciar as lutas políticas da Enfermagem pela sua valorização, reconhecimento e combate das desigualdades sociais, com ênfase no fator gênero. Descrição Metodológica: revisão integrativa levantada nas bases de dados LILACS e Scielo; o critério de inclusão dos artigos residiu naqueles que foram publicados a partir do ano de 2019. Descritores: lutas políticas da Enfermagem; enfrentamento das desigualdades sociais e questão de gênero. Resultados: as lutas políticas do movimento feminista e das profissionais de Enfermagem constituíram e constituem quebras de paradigmas necessários para a valorização e reconhecimento dessas profissionais e de suas expressões no tecido social; as desigualdades no campo da Enfermagem estão diretamente relacionadas, sobretudo, a questões de gênero. Conclusão: as desigualdades sociais deferidas contra a classe de profissionais de Enfermagem são potencializadas quando se trata do universo feminino, o que evidencia a discriminação de gênero que ainda é um estigma cultural e estrutural no contexto brasileiro; a desigualdade de gênero no campo da Enfermagem é produto de um sistema patriarcal, sexista e de validação da divisão sexual do trabalho. Contribuições/Implicações para a Enfermagem: o levante das lutas políticas em favor da Enfermagem incide positivamente na assistência à saúde com qualidade, regulação e prática da profissão, promoção de formação continuada, dentre outros aspectos.`,
    doi: '',
    link: 'https://biaticefb.bitrix24.com.br/~wi91C',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://www.edufma.ufma.br/',
  },
  {
    id: '7',
    tipo: 'Artigo científico',
    titulo:
      'Assistência aos hipertensos e diabéticos em uma unidade de saúde da família baseada no desempenho dos indicadores do Previne Brasil',
    autor: 'Cássio Bernardino Pinto Mangueira',
    autores: [
      'Cássio Bernardino Pinto Mangueira',
      'Milena Nunes Alves de Sousa',
    ],
    local: 'Itaporanga PB',
    ano: '2024',
    resumo: `O presente estudo analisou o desemprenho da Unidade de Saúde da Família (USF) Miguel Morato
situada no município de Itaporanga-PB frente à assistência prestada aos hipertensos e diabéticos através das
informações disponíveis no e-SUS e no SISAB. Foram avaliadas a cobertura de visitas domiciliares realizadas pelos
Agentes Comunitários de Saúde (ACS) aos Hipertensos e Diabéticos, a cobertura de atendimento médico e de
enfermagem realizados pela USF, a quantidade de diabéticos com exame de hemoglobina glicada realizadas, a
quantidade de consultas em hipertensos e aferição de PA realizadas pela USF. A cobertura de atendimento médico
e de enfermagem aos usuários hipertensos e/ou diabéticos foi avaliada através dos indicadores de desempenho de nº
6 e 7 do Previne Brasil. Ainda, as características sociodemográficas dos munícipes foram coletadas para
compreensão dos determinantes sociais que podem impactar na condição de saúde dos usuários. Dentre os 2898
usuários adscritos na USF, 1975 (68%) encontram-se com o cadastro atualizado e 937 (32%) desatualizados, estando
acima da média em relação ao município quanto à atualização dos cadastros. Destes, 112 são diabéticos, 385
hipertensos e 79 são hipertensos e diabéticos. Em relação a cobertura de visitas domiciliares realizadas pelo ACS,
63% das famílias cadastradas foram visitadas nos últimos 30 dias. Em relação ao desempenho dos indicadores 6 e
7, a USF superou a proporção de atendimentos realizados em relação ao município como um todo, realizando 583
atendimentos aos diabéticos nos últimos 2 semestres e 484 atendimentos a hipertensos no último semestre. O estudo
limitou-se a avaliação apenas das informações disponíveis nas plataformas, não podendo dessa forma avaliar o
impacto desses números da condição de saúde dos usuários. Fornecer subsídios para monitoramento por parte da
gestão o desempenho dos profissionais pode contribuir para o planejamento de ações futuras e fomentar a solicitação
de incrementos financeiros.`,
    doi: 'https://doi.org/10.18378/rbfh.v13i1.10352',
    link: 'https://www.gvaa.com.br/revista/index.php/RBFH/article/view/10352',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: '',
  },
  {
    id: '8',
    tipo: 'Artigo científico',
    titulo:
      'Avaliação do atributo acessibilidade na concepção das mulheres sobre a assistência ginecológica',
    autor: 'Luana Evelyng Lopes Ferreira',
    autores: [
      'Luana Evelyng Lopes Ferreira',
      'Moisés Celestino de Aguiar',
      'Arlete Rodrigues Chagas da Costa',
      'Lara Mabelle Milfont Boeckmann',
      'Suderlan Sabino Leandro',
      'Ageu Procópio Almeida de Albuquerque',
      'Rafaella Dayanny Lacerda Bomfim Soares',
    ],
    ano: '2024',
    local: 'Concilium',
    resumo:
      'Objetivo: Avaliar o atributo acessibilidade na concepção das mulheres sobre a assistência ginecológica em uma Unidade Básica de Saúde do Distrito Federal, Brasil. Método: Trata-se de um estudo descritivo exploratório do tipo transversal com abordagem quantitativa. Resultados: Mostraram que majoritariamente o atributo acessibilidade na Atenção Primária em saúde ainda é um grande embate, e várias problemáticas persistem como as barreiras geográficas e o acesso dificultado pela organização do serviço, o que evidencia a necessidade de romper com as práticas de cuidado cotidianas que dificultam a entrada, o acesso, o acolhimento e a transmissão de informação. Conclusão: É preciso organizar formas de ofertas de saúde mais inclusivas, que visem um acolhimento de qualidade, com uma visão holística do ser como um todo, fundamental para melhor organização do sistema de serviços de saúde nas regiões de saúde.',
    doi: '',
    link: 'https://www.researchgate.net/publication/378667712_Evaluation_of_the_accessibility_attribute_in_the_conception_of_women_about_gynecological_assistance_Avaliacao_do_atributo_acessibilidade_na_concepcao_das_mulheres_sobre_a_assistencia_ginecologica',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
  },
  {
    id: '9',
    tipo: 'Artigo científico',
    titulo:
      'Análise dos indicadores de desempenho da atenção primária do município de Porto Velho – RO',
    autor: 'Gabriel Chiarelli Dias',
    autores: [
      'Gabriel Chiarelli Dias',
      'Rafael Saraiva Carvalho',
      'Ahmed Muhammad Zaglout',
      'Fabiano Patricio Resende',
      'Leonardo Pappis Orso',
      'Pedro Henrique Nascimento Miguel',
      'Ulisses Gonçalves Norberto',
      'Victor Alves de Oliveira',
      'Layza Karyne Farias Mendes',
      'Suyane da Costa Oliveira',
    ],
    local: 'Porto Velho – RO',
    ano: '2024',
    resumo: `Objetivo: Avaliar os indicadores de desempenho da atenção primária (Portaria n° 2.979/2019 – Programa Previne Brasil) do município de Porto Velho – RO e identificar reflexos da perda financeira por desempenho. Métodos: Utilizou-se o Sistema de Informação em Saúde da Atenção Básica (SISAB) para recuperar os resultados dos sete indicadores do Programa Previne Brasil nos três quadrimestres de 2022. O eSUS feedback foi utilizado para avaliar o desempenho geral do município de 2018 a 2022. As perdas financeiras relativas ao Indicador Sintético Final (ISF) foram identificadas através do Fundo Nacional de Saúde. Resultados: Porto Velho possui uma população estimada de 548.952 habitantes (IBGE). No último quadrimestre de 2022 alcançou-se o maior número de indivíduos cadastrados na Atenção Básica do município (323.648). Quanto aos indicadores do Programa Previne Brasil, com exceção dos exames de sífilis e HIV em gestantes no último quadrimestre de 2022, os demais indicadores e o ISF ficaram abaixo das metas do Ministério da Saúde no período analisado, ocasionando perdas financeiras superiores a 2,5 milhões de reais. Conclusão: Os indicadores do Previne Brasil em Porto Velho encontram-se abaixo das metas estabelecidas pelo Ministério da Saúde, tendo os cadastros um reflexo direto nos indicadores e consequentemente no Índice Sintético Final.`,
    doi: 'https://doi.org/10.25248/REAS.e15115.2024',
    link: 'https://acervomais.com.br/index.php/saude/article/view/15115',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: '',
  },
  {
    id: '10',
    tipo: 'Artigo científico',
    titulo:
      'Estratégias para melhoria da cobertura vacinal de Itabaianinha (SE) com parcerias intersetoriais',
    autor: 'Suelly Lima dos Santos',
    autores: [],
    ano: '2023',
    resumo: '',
    doi: '',
    local: 'Itabaianinha SE',
    link: 'https://ideiasus.fiocruz.br/praticas/estrategias-para-melhoria-da-cobertura-vacinal-de-itabaianinha-com-parcerias-intersetoriais-se/',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
  },
  {
    id: '10-1',
    tipo: 'Artigo científico',
    titulo:
      'Continuous six-month follow-up of patients with diabetes and hypertension: how to bring those people to the health unit?',
    autor: 'David Alex Magalhães Barreira',
    autores: ['David Alex Magalhães Barreira', 'Milena Nunes Alves de Sousa'],
    ano: '2024',
    local: 'UNIFIP',
    resumo:
      'Affecting almost 20% of the population, Systemic Arterial Hypertension is a chronic disease characterized by high blood pressure levels, influenced by genetic, epigenetic, social and environmental factors. Diabetes Mellitus (DM) is characterized by insufficient production and/or malabsorption of insulin. Both are directly related, especially when without good control, with poor outcomes in several other pathologies. This is a descriptive study, of the experience report type, developed at the Basic Health Unit Metódio de Araújo Leitão, in the Municipality of Patos-PB, in the second half of 2022, using the problematizing method proposed by Arco de Charles Maguerez as a guide. After applying the method, it was seen that there was a deficit in the unit in the performance indicators proposed by the Ministry of Health, regarding the monitoring of hypertensive and diabetic patients, and this was the key point of application of the work, in order to bring these patients for follow-up in the unit. Focusing mainly on our initial problem, related to hypertensive and diabetic patients, we saw a jump in the period in question with the application, leaving a follow-up percentage of 30% for hypertensive and 34% for diabetics in the month of June 6/2022, with a peak in the month of August 8/2022, when we reached 53% of hypertensives and 56% of hypertensives, maintaining good levels until the end of the year. Thus, the Arch of Maguerez proved to be, as a method, resolving issues such as the one we applied, mainly due to its steps of easy application and systematization. As well as we saw that the active search is the main way to bring these patients to age for follow-up, as well as the need for participation of the entire team.',
    doi: 'https://doi.org/10.55905/revconv.17n.2-106',
    link: 'https://ojs.revistacontribuciones.com/ojs/index.php/clcs/article/view/4397',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://fiponline.edu.br/',
  },
  {
    id: '11',
    tipo: 'TCC',
    titulo:
      'INDICADOR DE DESEMPENHO PREVINE BRASIL NOS MUNICÍPIOS DAMESORREGIÃOSUL CATARINENSE SOB A ÓTICA DOS ENFERMEIROS',
    autor: 'LETHÍCIA BORGES',
    autores: [],
    local: 'UNESC',
    ano: '2023',
    resumo: `O SUS é um dos maiores sistemas de saúde pública do mundo e que
abrange desde os a atendimentos mais simples aos mais complexos, garantindo a
saúde como um todo, desde o início ao final do processo de saúde de cada
indivíduo. No entanto, por ser este grande sistema de saúde, sofre com baixo
financiamento, gestão despreparada e profissionais que necessitam de educação
permanente relacionado a gestão de serviços. O programa Previne Brasil surge
como um incentivador de melhoria no SUS, com indicadores de desempenho que
devem ser alcançados para obtenção de uma boa classificação, fazendo com que
assim as unidades básicas de saúde consigam um repasse financeiro maior.
Objetivo: O presente estudo teve como objetivo identificar o desempenho do
Programa Previne Brasil, nos municípios da mesorregião Sul Catarinense conforme
portaria nº 2.979/2019. Metodologia: Trata-se de uma pesquisa qualitativa de
cunho descritivo e exploratório com delineamento transversal. Foi realizada através
da análise dos indicadores nos 45 municípios compostos desta região e com a
participação de enfermeiros que trabalham nestes municípios. A análise dos dados
foi realizada a partir da análise de conteúdo. Resultados: Todos os municípios da
Mesorregião do Sul Catarinense começaram o programa com notas insatisfatórias,
entretanto conseguiram se adaptar e melhorar os indicadores de desempenho a
cada novo quadrimestre, entre os entrevistados a grande dificuldade apontada por
eles foi a dificuldade de incompatibilidade de dados dos sistemas utilizados.
Conclusão: Foi possível constatar que o programa Previne Brasil incentivou a
melhoria no desempenho das unidades de saúde pública da Mesorregião Sul
Catarinense.`,
    doi: '',
    link: 'http://200.18.15.28/bitstream/1/10547/1/Leth%C3%ADcia%20Borges.pdf',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://www.unesc.net/',
  },
  {
    id: '12',
    tipo: 'Artigo científico',
    titulo:
      'EXAME CITOLÓGICO: CONHECIMENTO E PRÁTICA DE UM GRUPO DE MULHERES ATENDIDAS NA REDE PÚBLICA DE SAÚDE',
    autor: 'Vanessa Vieira Eufrasio',
    autores: [
      'Vanessa Vieira Eufrasio',
      'Giovani Amado Rivera',
      'Erta Soraya Ribeiro César Rodrigues',
      'Keylla de Lacerda Brandao',
    ],
    local: 'UNIFIP',
    ano: '2023',
    resumo:
      'O exame citopatológico é um teste realizado para detectar alterações nas células do colo do útero. Sua finalidade é a detecção da doença em busca de prevenir o câncer de colo de útero, pois, a partir da identificação de lesões pré-malignas, é possível trata-las para não permitir sua evolução. Neste contexto, objetivou-se avaliar o nível de conhecimento das mulheres acerca do exame citopatológico no município de Coremas-PB, bem como a identificação do perfil dessas mulheres. A metodologia utilizada para a coleta de dados trata-se de uma pesquisa de campo, exploratória do tipo descritiva com abordagem quantitativa, baseada na aplicação de um questionário impresso pré-estabelecido pela autora, e aplicado em mulheres que realizam o exame citopatológico na Unidade Básica de Saúde da cidade de Coremas – PB. Foram analisados os resultados de 32 participantes, onde 96,9% delas são consideradas adultas com idade entre 20 e 59 anos (M=38; DP=10,8). Como principais resultados, 100% das mulheres responderam ter conhecimento acerca da importância da realização e do rastreamento do exame citopatológico, bem como diagnosticar o câncer do colo do útero. Entre elas, 93,8% já realizaram o exame citopatológico e 37,5% delas fazem isso anualmente. Em relação aos fatores associados a não realização do exame, 59,4% responderam que seria por falta de interesse. Quanto as razões que as levam a não realização do exame, 36,4% delas disseram que não o faz pela demora do resultado. Dessa forma, conclui-se que, no geral, as respostas das participantes foram positivas acerca do conhecimento do exame, porém, apesar desse conhecimento específico, ainda algumas delas nunca realizaram o exame citológico (ou realizam raramente).',
    doi: '',
    link: 'https://enfermagemesaude.unifip.edu.br/index.php/enfermagemesaude/article/view/76/33',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://unifip.edu.br/inicio',
  },
  {
    id: '13',
    tipo: 'Manual',
    titulo:
      'Manual Operacional - Sistema Digital de Gestão na Atenção Primária Saúde',
    autor: 'Mailson Silva de Oliveira',
    autores: [
      'Mailson Silva de Oliveira',
      'Fábio Júnior Francisco da Silva',
      'Fernando Lopes e Silva Júnior',
    ],
    local: 'Parnaíba PI',
    ano: '2024',
    resumo: `Bem-vindo ao manual operacional do eSUS Feedback, um
software web de gestão em saúde desenvolvido para a
modernização e aprimoramento do monitoramento e avaliação das
ações e serviços de saúde ofertados pela Atenção Primária à Saúde
(APS) no Brasil. O eSUS Feedback surge como uma ferramenta
essencial para apoiar a gestão eficiente e eficaz dos serviços de
saúde, melhorando a gestão da informação em saúde e facilitando
o acompanhamento de ações estratégicas e indicadores de
desempenho no âmbito do cofinanciamento federal da APS.
Este sistema é concebido para ser intuitivo e de fácil utilização,
permitindo que os profissionais de saúde se concentrem na
prestação de cuidados de qualidade sem a preocupação com
custos adicionais, uma vez que o uso do eSUS Feedback não
acarreta ônus adicional. No entanto, é imprescindível que a
Secretaria Municipal de Saúde adquira a licença necessária para
que os profissionais possam acessar todas as funcionalidades
oferecidas pelo sistema.
Ao longo deste manual, forneceremos orientações sobre como
utilizar o eSUS Feedback de maneira eficiente, abrangendo desde o
cadastro inicial até a operação diária para resolução de problemas
comuns. Nosso objetivo é garantir que todos os profissionais com
atuação na APS estejam plenamente capacitados para aproveitar
ao máximo os recursos do sistema, contribuindo para a melhoria
contínua dos serviços de saúde na APS.
A implementação do eSUS Feedback nas unidades de saúde
representa um passo significativo rumo a inovação na gestão da
saúde pública, promovendo um sistema mais ágil, transparente e
seguro, capaz de diminuir a sobrecarga de trabalho dos gestores ao
fornecer informações em tempo hábil para a tomada de decisões.
Esperamos que este manual seja uma ferramenta valiosa para
todos os profissionais envolvidos e que a utilização do eSUS
Feedback transforme positivamente a experiência de gestão e
atendimento na APS.`,
    doi: '',
    link: '',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: '',
  },
  {
    id: '14',
    tipo: 'Artigo científico',
    titulo:
      'Prevalência de transtornos de humor e abordagem psicológica na UBSi deDiamante-PB',
    autor: 'Ana Rosa Cartaxo Mangueira',
    autores: ['Milena Nunes Alves de Sousa'],
    local: 'UNIFIP',
    ano: '2024',
    resumo:
      'Identificar a prevalência de transtornos de humor na Unidade Básica de Saúde I do município de Diamante, na Paraíba. Metodologia: Trata-se de uma pesquisa documental de abordagem quantitativa, utilizando dados secundários do Prontuário Eletrônico do Cidadão (PEC) e do sistema eSUS Feedback. Resultados: Os achados indicaram, portanto, uma prevalência de 13,63% na população analisada. O número total de pacientes adscritos é de 2.200 pessoas, das quais 300 (203 mulheres e 97 homens) apresentam diagnósticos de transtornos de humor, dentre os quais 03 são gestantes e 15 adolescentes. Desses pacientes, 127 são acompanhados no Centro de  Atenção  Psicossocial  (CAPS)  municipal.  Conclusão:  Os  transtornos  de  humor  representam  um  desafio significativo  para  a  saúde  pública,  dada  sua  alta  prevalência  e  impacto  na  qualidade  de  vida  dos  indivíduos. Portanto, fortalecer a atenção básica com profissionais de psicologia é essencial para a promoção da saúde mental e a prevenção de transtornos psicológicos.Palavras-Chave:saúde mental; atenção básica; saúde pública.',
    doi: '',
    link: 'https://editora.unifip.edu.br/index.php/coopex/article/view/5994/6229',
    url: 'https://bitrix24public.com/biaticefb.bitrix24.com.br/docs/pub/a52ca4966d517633e8cf38aaf22f4031/default/?&',
    url_local: 'https://fiponline.edu.br/',
  },
  {
    id: '15',
    tipo: 'Artigo científico',
    titulo:
      'Relatorio municipal Cacimba de area: 2º Relatório Detalhado do Quadrimestre Anterior 2021.',
    autor: 'RAQUEL DE LIRA CAMPOS',
    autores: ['RAQUEL DE LIRA CAMPOS'],
    local: 'Cacimba de area PB',
    ano: '2021',
    resumo:
      'O município implantou o sistema PEC e o eSUS Feedback, o que permitiu dispor de dados mais fiéis à realidade populacional e de produtividade local. Essa implantação foi destacada como uma ferramenta importante para subsidiar a análise da gestão em saúde, especialmente no enfrentamento de doenças crônicas e causas externas.',
    doi: '',
    link: 'https://cacimbadeareia.pb.gov.br/images/arquivos/documentos/1731582996.pdf',
    url: '',
    url_local: '',
  },
  {
    id: '16',
    tipo: 'Estudo Técnico',
    titulo:
      'Tribunal de contas da Paraíba, estudo tecnico 01/2024 Indicadores Socieconômicos e Ambientais: Das 20 maiores cidades da Paraíba.',
    autor: 'Ana Rosa Cartaxo Mangueira',
    autores: ['André Agra Gomes de Lira'],
    local: 'TCE',
    ano: '2024',
    resumo:
      'O estudo utilizou dados do 3º quadrimestre de 2023 do eSUS Feedback para calcular o Indicador Sintético Final (ISF) do programa Previne Brasil, permitindo classificar os municípios paraibanos quanto à qualidade da atenção primária à saúde.',
    doi: '',
    link: 'https://tce.pb.gov.br/wp-content/uploads/2024/12/INDICADORES2024CIDADES-1.pdf',
    url: '',
    url_local: 'https://tce.pb.gov.br/',
  },
  {
    id: '17',
    tipo: 'TCC',
    titulo:
      'DESAFIOS DAS EQUIPES DE SAÚDE NO CUMPRIMENTO DE METAS DO PREVINE BRASIL.',
    autor: 'ISMAILDO CAETANO DE MEDEIROS',
    autores: [
      'ALINE SÁTYRO DANTAS',
      'ISMAILDO CAETANO DE MEDEIROS',
      'LUCAS BARBOSA PEREIRA',
      'SILVINO CHAVES DE LUCENA',
      'VITORIA DE ARAÚJO FRANÇA',
    ],
    local: 'UNIPLAN',
    ano: '2024',
    resumo:
      'A Atenção Primária à Saúde, como componente organizador das redes de assistência à saúde, deve estar atenta às necessidades dos usuários, colaborando na elaboração de programas de saúde e facilitando  o  planejamento  ascendente. Com a introdução do Programa Previne Brasil, um novo modelo de financiamento da APS foi estabelecido, Questionam-se quais desafios às equipes de saúde enfrentam para  o  cumprimento  de  metas.  Trata-se  de  uma  pesquisa  exploratória,  com abordagem  qualitativa,  que  foi  desenvolvida  nas  Unidades  Básicas  de  Saúde  na cidade de Nova Olinda, localizada no sertão paraibano. A cidade conta com 03 UBS distribuídas na zona urbana e rural. A população de estudo conta com profissionais de saúde da atenção primária do Município de Nova Olinda-PB.  Foram incluídos os profissionais que atuam na UBS há mais de seis meses e que aceitem participar da pesquisa.  Sendo  excluídos  aqueles  que  se  encontram  de  ferias,  licença  ou  que estejam afastados por outro motivo, no período da coleta. Para a coleta de dados foi elaborado previamente um questionário contendo perguntas tanto subjetivas quanto objetivas,  abordando  o  tema  proposto.  Os  dados  foram  submetidos  à  técnica  de análise de conteúdo, modalidade temática, com a possibilidade de identificação de categorias  temáticas  para  uma  apresentação  mais  eficaz  dos  resultados  obtidos. Para  assegurar  o  anonimato  dos  profissionais  voluntários,  sendo  identificados  por meio  da  abreviação  da  categoria  e  números.  Foram  entrevistados  11  profissionais das  equipes  da  atenção  primária  da  cidade  de  Nova  Olinda,  constituída  médicos, enfermeiros, técnicos de enfermagem e dentistas. Os resultados demonstram que os profissionais  sentem-se  seguros  em  atingir  as  metas  dos  indicadores,  já  sobre  a frequência de realizações de capacitações e treinamento, os profissionais disseram que  raramente  são  feitos.  Quando  indagados  sobre  sua  avaliação  dos  recursos financeiros a maioria dos profissionais, responderam que não sabiam ou não podiam opinar. Quanto aos indicadores que os mesmos tinham mais dificuldade em alcançar a meta os mais recorrentes foram: proporção de mulheres com coletas de citológicos na APS e proporção de pessoas com hipertensão, com consulta e pressão arterial aferida semestralmente. Sobre os principais desafios os profissionais mencionaram a  adesão  dos  usuários  e  a  sobrecarga  dos  profissionais  foram  os  desafios  mais apresentados,  já  quanto  às  dificuldades  e  desafios  sobre  a  informatização, problemas  com  a  conexão  da  internet  e  a  falta  de  capacitação  do  profissional  em alimentar o sistema foram os obstáculos mais mencionados. Quando questionados sobre possíveis sugestões para melhoria do serviço, foi relatada desde investimento na  infraestrutura  das  unidades,  a  valorização  profissional,  contratação  de  novos profissionais, uso de atendimentos por telemedicina, organização dos atendimentos, comprometimento  dos  gestores  com  as  verbas  que  são  destinadas  à  atenção básica.  O  programa  Previne  Brasil  foi  criado  com  o  intuito  de  melhorar  o financiamento  da  atenção  básica,  levando  em  consideração  o  desempenho  das equipes,  porém  nota-se  que  mesmo  com  os  profissionais  realizando  as  medidas solicitadas pelo programa, as metas não são totalmente alcançadas.',
    doi: '',
    link: 'https://biaticefb.bitrix24.com.br/~VNFk9',
    url: '',
    url_local: 'https://www.uniplandf.edu.br/',
  },
  {
    id: '18',
    tipo: 'Dissertação',
    titulo: 'Prêmio UFDPar de Dissertação 2024.',
    autor: 'Maílson Silva de Oliveira',
    autores: ['Maílson Silva de Oliveira'],
    local: 'UFDPar',
    ano: '2024',
    resumo:
      'Sistema digital de gestão na atenção primária à saúde: estudo de validação, de Maílson Silva de Oliveira. Orientador: Prof. Dr. Fernando Lopes e Silva Junior (PPG em Saúde da Família – PROFSAÚDE).',
    doi: '',
    link: 'https://ufdpar.edu.br/ufdpar/noticias-1/propopi-realiza-solenidade-de-entrega-do-premio-ufdpar-de-dissertacao-2024',
    url: '',
    url_local: 'https://ufdpar.edu.br/',
  },
  {
    id: '19',
    tipo: 'Artigo científico',
    titulo:
      'EM BUSCA DOS INVISÍVEIS: PROJETO BONITO DOA VIDA, UM RELATO DE EXPERIÊNCIA.',
    autor: 'Mylena Ramos Gonçalves',
    autores: [
      'Mylena Ramos Gonçalves',
      'Marli Ribeiro da Silva',
      'Fagna Rodrigues da Silva Pereira',
      'Erica Emengarda Luciano',
      'Aldara Cristina Alves Araruna',
      'Ankilma do Nascimento Andrade Feitosa',
      'Yuri Charllub Pereira Bezerra',
      'Renata Livia Silva Fonseca Moreira de Medeiros',
    ],
    local: 'Revista Contemporânea',
    ano: '2025',
    resumo:
      'O presente relato de experiência aborda o projeto "Bonito Doa Vida", desenvolvido no município de Bonito de Santa Fé (PB), como estratégia para estimular a doação de sangue e promover o autocuidado em saúde. A ação foi realizada por profissionais da Estratégia Saúde da Família em parceria com instituições locais e regionais. O projeto buscou alcançar públicos historicamente afastados dos serviços de saúde, utilizando a doação de sangue como porta de entrada para o cuidado integral. Foram ofertados exames básicos, testagens rápidas, vacinação, atendimento médico e ações educativas, promovendo a saúde de forma acessível e acolhedora. Além da captação de doadores, o projeto teve como objetivo o fortalecimento do vínculo entre comunidade e equipe de saúde. A experiência demonstrou que ações intersetoriais, sensíveis ao território e às necessidades locais, podem transformar a prática em saúde e ampliar o acesso da população aos serviços.',
    doi: 'https://doi.org/10.56083/RCV5N4-058',
    link: 'https://ojs.revistacontemporanea.com/ojs/index.php/home/article/view/7927',
    url: '',
    url_local: 'https://revistacontemporanea.com/',
  },
  {
    id: '20',
    tipo: 'Experiência Exitosa',
    titulo:
      'O USO DE ESTRATÉGIAS E DADOS QUALIFICADOS PARA UMA IMUNIZAÇÃO DE SUCESSO: RELATO DE UM MUNICÍPIO PILOTO E UMA EXPERIÊNCIA EXITOSA.',
    autor: 'GOVERNO DA PARAIBA',
    autores: ['GOVERNO DA PARAIBA'],
    local: 'I MOSTRA VACINA MAIS PARAÍBA IMUNIZAÇÃO',
    ano: '2024',
    resumo:
      'Este relato descreve de forma prática, critica-reflexiva, a experiencia e a rotina de uma coordenadora de imunização do município de Matinhas na Paraíba. Os desafios diários, a necessidade de atualização, o sucesso do planejamento, do uso qualificado de dados e a parceira gestão e equipe. Mostrando que a junção de diversos fatores contribui diretamente para uma busca vacinal eficaz e eventualmente a elevação da cobertura vacinal.',
    doi: '',
    link: 'https://ideiasus.fiocruz.br/wp-content/uploads/2025/04/Resumo-expandido-Matinhas.pdf',
    url: '',
    url_local: '',
  },
  {
    id: '21',
    tipo: 'Simpósio',
    titulo:
      'SISTEMA DIGITAL DE GESTÃO NA ATENÇÃO PRIMÁRIA À SAÚDE: ESTUDO DE VALIDAÇÃO.',
    autor: 'Maílson Silva de Oliveira',
    autores: [],
    local: 'MACEIÓ - AL',
    ano: '2024',
    resumo:
      'Este estudo teve como objetivo validar o eSUS Feedback, um sistema digital de gestão na atenção primária à saúde.',
    doi: '',
    link: 'https://www.seer.ufal.br/index.php/nuspfamed/article/view/19860',
    url: '',
    url_local: '',
  },
  {
    id: '22',
    tipo: 'Trabalhos premiados - 30º Encontro da Rede UNA-SUS',
    titulo:
      'Validação de conteúdo e de aparência do eSUSFeedback: um sistema digital de gestão em saúde.',
    autor: 'Mailson Silva de Oliveira',
    autores: [
      'Mailson Silva de Oliveira',
      'Tamara de Oliveira Linhares',
      'Fernando Lopes e Silva Junior',
    ],
    local: 'Revista de Saúde Digital e Tecnologias Educacionais (RESDITE)',
    ano: '2025',
    resumo:
      'O objetivo deste estudo foi realizar a validação de conteúdo e aparência do sistema digital de  gestão  eSUSFeedback.  Trata-se  de  um  estudo  observacional  transversal,  em  que  foi aplicado instrumento de avaliação, com perguntas tipo likert, a uma amostra de 37 juízes e, posteriormente,  calculado  o  índice  de  validade  de  conteúdo.  A  maioria  dos  avaliadores eram  gestores  de  unidades  básicas  de  saúde,  enfermeiros  especialistas,  com  média  de 12,1 anos de atuação na atenção primária à saúde. O sistema foi validado obtendo o índice de validação de conteúdo de 0,88 e aparência de 0,83. O sistema foi validado, devendo ser considerado como uma importante tecnologia digital para gestão em saúde, monitoramento e avaliação na atenção primária.',
    doi: 'https://doi.org/10.36517/resdite.v9i7',
    link: 'https://biaticefb.bitrix24.com.br/~8TOph',
    url: '',
    url_local: 'https://periodicos.ufc.br/resdite',
  },
  {
    id: '23',
    tipo: 'Artigo científico',
    titulo:
      'Usabilidade do sistema eSUS Feedback por gestores de Unidades Básicas de Saúde',
    autor: 'Mailson Silva de Oliveira',
    autores: [
      'Mailson Silva de Oliveira',
      'Fábio Solon Tajra',
      'Ivana Cristina de Holanda Cunha Barrêto',
      'Fernando Lopes e Silva-Júnior',
    ],
    ano: '2025',
    local: 'SciELO Brasil',
    resumo:
      'Com a utilização crescente de intervenções em saúde digital na Atenção Primária à Saúde (APS), estudos são necessários para avaliar a efetividade, a segurança e o impacto de tais tecnologias. Avaliaramse a usabilidade e a experiência do usuário do sistema digital de gestão eSUS Feedback por gestores de unidades básicas de saúde no Brasil. Estudo observacional transversal em que foram aplicados o System Usability Scale e o User Experience Questionnaire a uma amostra de 37 e 35 participantes respectivamente. A pesquisa foi realizada entre maio e junho de 2024, abrangendo principalmente a região Nordeste. A usabilidade foi avaliada com pontuação média de 77,5, classificando o sistema como aceitável e excelente. A experiência do usuário foi avaliada como positiva geral, exceto na categoria inovação, que foi neutra. Os resultados destacam a importância das tecnologias digitais na gestão da APS, sugerindo que o eSUS Feedback é uma ferramenta viável, eficiente e confiável. No entanto, são necessários o aprimoramento dessa inovação e o registro de retorno dos usuários. A implementação de sistemas digitais de gestão em saúde é fundamental para a coordenação de cuidados e gestão de informações, alinhando-se às recomendações da Estratégia Global de Saúde Digital 2020-2025 da Organização Mundial da Saúde.',
    doi: 'https://doi.org/10.1590/2358-28982025E19981P ',
    link: 'https://www.scielo.br/j/sdeb/a/WKRjZjRh7mHHfDDCsz8NZjL/?lang=pt',
    url: '',
    url_local:
      'https://www.scielo.br/j/sdeb/a/WKRjZjRh7mHHfDDCsz8NZjL/?lang=pt',
  },
  {
    id: '24',
    tipo: 'Artigo científico',
    titulo:
      'Análise dos indicadores de pré-natal sob a perspectiva do Previne Brasil em uma região de saúde da Bahia: um panorama de 2022 e 2023',
    autor: 'Bianca Fernandes Silva',
    autores: [
      'Bianca Fernandes Silva',
      'Gustavo Alves Pina',
      'Bruno Vidal Andrade',
      'Fábio Silva de Carvalho',
      'Cristiane Alves Paz De Carvalho',
    ],
    ano: '2025',
    local: 'Revista saude.com',
    resumo:
      'Iniciativas que busquem a qualificação da atenção obstetrícia são necessárias e prioritárias no desenvolvimento de políticas públicas em território nacional. Monitorar e avaliar as políticas de saúde voltadas às gestantes torna-se ainda mais necessário quando se observa no país menor adesão ao pré-natal para as mulheres residentes nas regiões Norte e Nordeste. O objetivo desse estudo foi analisar o desempenho dos indicadores do pré-natal em uma região de saúde da Bahia, sob a ótica dos resultados do Previne Brasil, nos anos de 2022 e 2023. Trata-se de um estudo com agregado de população, que analisou os indicadores do pré-natal da região de saúde de Seabra, Bahia. Os dados coletados foram provenientes do Sistema de Informação em Saúde para a Atenção Básica, sendo considerado o período de 2022 a 2023. O Índice de Vulnerabilidade Social e o Índice de Gini foram utilizados para caracterização socioeconômica dos municípios da região. Para análise dos dados, foi realizado o cálculo da média dos quadrimestres, seguido da classificação de acordo com o estabelecido pelo Ministério da Saúde. Foi possível identificar um avanço nos indicadores, ainda que existam lacunas na avaliação da qualidade da assistência. O presente estudo apontou a necessidade de analisar a qualidade dos indicadores na avaliação do pré-natal, bem como capacitar o serviço prestado pela gestão e equipe de saúde.',
    doi: 'https://doi.org/10.22481/rsc.v21i1.17185 ',
    link: 'https://periodicos2.uesb.br/rsc/article/view/17185',
    url: '',
    url_local:
      'https://periodicos2.uesb.br/rsc/index',
  },
  {
    id: '25',
    tipo: 'Prática em saúde (SUS)',
    "titulo": "Impacto do curso Saúde com Agente no indicador de citopatológico da UBS Mãe Pobre em Itabaiana (PB)",
    "autor": "Flávia Ramos de Almeida",
    "autores": [
      "Flávia Ramos de Almeida"
    ],
    "ano": "2025",
    "local": "IdeiaSUS / Fiocruz",
    "resumo": "Avaliação da evolução da cobertura do exame citopatológico na UBS Mãe Pobre (Itabaiana-PB) entre 2022 e 2024, após a qualificação de agentes comunitários de saúde por meio do curso técnico Saúde com Agente. Observou-se aumento na cobertura do exame, associada a ações como busca ativa domiciliar, panfletagem e comunicação via WhatsApp, reforçando a importância da educação em saúde e qualificação técnica para a prevenção do câncer de colo uterino.",
    "doi": "",
    "link": "https://ideiasus.fiocruz.br/praticas/impacto-do-curso-saude-com-agente-no-indicador-de-citopatologico-da-ubs-mae-pobre-em-itabaianapb/",
    "url": "",
    "url_local": "https://ideiasus.fiocruz.br/"
  },  
  {
    id: '26',
    tipo: 'E-book',
    "titulo": "Paraíba Aqui Tem SUS 2020–2024",
    "autor": "Fundação Oswaldo Cruz (Fiocruz-RJ) / IdeiaSUS",
    "autores": [
      "Mário Moreira (Presidente da Fiocruz)",
      "Valber da Silva Frutuoso (Coordenador de Relações Institucionais - Fiocruz)",
      "Wagner Barbosa de Oliveira (Coordenador da Plataforma IdeiaSUS)",
      "Claudia Beatriz Le Cocq D’Oliveira (Analista Sênior - IdeiaSUS Fiocruz, Curadora)",
      "Marta Gama de Magalhães (Analista de Gestão em Saúde - IdeiaSUS Fiocruz, Curadora)",  
      "André Luis Bonifácio de Carvalho (Docente - Departamento de Promoção da Saúde - UFPB)",
      "Gabriella Barreto Soares (Docente - Departamento de Promoção da Saúde - UFPB)",
      "Dayanne Sperle Campos (Discente - Medicina - UFPB)",
      "Gabriell Bruno Matias Pontes (Discente - Medicina - UFPB)",
      "Maria Eduarda Silva Dias (Discente - Medicina - UFPB)",
      "Yasmin Guimarães Silva (Discente - Medicina - UFPB)"
    ],
    "ano": "2025",
    "local": "COSEMS-PB",
    "resumo": "E-book institucional que reúne os trabalhos e resumos premiados nas Mostras 'Paraíba Aqui Tem SUS' entre 2020 e 2024. A obra apresenta práticas exitosas de saúde pública realizadas em diversos municípios paraibanos, valorizando iniciativas inovadoras, educação permanente, gestão participativa e fortalecimento do SUS.",
    "doi": "",
    "link": "https://cosemspb.org/wp-content/uploads/2025/08/e-book-PARAIBA-AQUI-TEM-SUS-2020-A-2024.pdf",
    "url": "",
    "url_local": "https://cosemspb.org/e-book-reune-experiencias-exitosas-do-sus-na-paraiba-das-mostras-entre-2020-e-2024/"
  },  
  {
    id: '27',
    tipo: 'Relato de Experiência',
    "titulo": "A importância da qualificação de dados para o alcance das altas coberturas vacinais",
    "autor": "Francielly Kely de Souza Galdino",
    "autores": [
      "Francielly Kely de Souza Galdino"
    ],
    "ano": "2025",
    "local": "I Mostra Vacina Mais Paraíba (IdeiaSUS / Fiocruz)",
    "resumo": "A vacinação no Brasil é considerada uma das estratégias mais eficazes e econômicas para o controle e prevenção de doenças, sendo prioritária nas políticas públicas de saúde. Para garantir a erradicação, eliminação ou controle de doenças imunopreveníveis, a Organização Mundial da Saúde (OMS) recomenda que a cobertura vacinal mínima seja de 95%, com equidade no acesso às vacinas e homogeneidade na distribuição das doses entre os municípios. A cobertura vacinal é um indicador essencial de saúde pública e é monitorada pelo Programa Nacional de Imunização (PNI) para garantir adequação das coberturas e prevenir surtos de doenças.",
    "doi": "",
    "link": "https://ideiasus.fiocruz.br/wp-content/uploads/2025/04/A-IMPORTANCIA-DA-QUALIFICACAO-DE-DADOS-PARA-O-ALCANCE-DAS-ALTAS-COBERTURAS-VACINAIS.pdf",
    "url": "",
    "url_local": "https://ideiasus.fiocruz.br/"
  },
  {
    id: '28',
    tipo: 'Relato de Experiência',
    "titulo": "Construção de Manual Operacional do eSUS Feedback: um relato de experiência",
    "autor": "Mailson Silva de Oliveira",
    "autores": [
        "Mailson Silva de Oliveira",
        "Joana Nágila Ribeiro Figueira",
        "Fernando Lopes",
        "Silva Junior"
    ],
    "ano": "2026",
    "local": "Revista Saúde em Redes",
    "resumo": "Objetivo: descrever o processo de construção do 'Manual Operacional do eSUSFeedback', um sistema digital voltado para a gestão de informações na Atenção Primária à Saúde. Breve descrição da experiência: Este manual operacional foi elaborado como produto técnico da dissertação de mestrado em Saúde da Família (PROFSAUDE). A construção do manual foi dividida em três etapas: formação de um grupo de trabalho, elaboração teórica baseada em revisão integrativa da literatura, e diagramação do conteúdo. O resultado foi um manual que aborda desde as funcionalidades básicas do sistema até aspectos avançados, como o monitoramento de indicadores e o apoio à gestão de cofinanciamento federal da APS. Considerações finais: A experiência evidenciou a importância de alinhar as necessidades práticas dos usuários com bases teóricas robustas, destacando a relevância das tecnologias digitais para a modernização da APS. O manual oferece uma ferramenta valiosa para melhorar a eficiência da gestão e a tomada de decisões, promovendo a transformação digital nos serviços de saúde.",
    "doi": "https://doi.org/10.18310/2446-4813.2026v12nsup3.4782",
    "link": "https://revista.redeunida.org.br/index.php/rede-unida/article/view/4782",
    "url": "",
    "url_local": "https://revista.redeunida.org.br/"
  }
]
